import { Component, ChangeDetectionStrategy } from "@angular/core";
import { RaskColumnButtonTypes } from "../../models/rask-column";
import { GridBaseComponent } from "../grid-base/grid-base.component";
import { ButtonComponent } from "../../../button/button.component";

@Component({
    selector: "rask-grid-button",
    template: `@if (isDeleteButton()) {
  <rask-button [disabled]="disabled" (click)="click()" [icon]="icon()" color="Tertiary" class="cell grid-button-fit" negative>
    {{text}}
  </rask-button>
}
@if (!isDeleteButton()) {
  <rask-button [disabled]="disabled" (click)="click()" [icon]="icon()" color="Tertiary" class="cell grid-button-fit">
    {{text}}
  </rask-button>
}`,
    styleUrls: ["./grid-button.component.scss"],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [ButtonComponent]
})
export class GridButtonComponent extends GridBaseComponent {
    click = () => {
        this.onClick(this.row);
    };

    icon(): string {
        let btnType = this.buttonType;
        if(typeof(this.buttonType) === "function") {
            btnType = this.buttonType(this.row);
        }
        switch (btnType) {
            case RaskColumnButtonTypes.delete:
                return "far fa-trash-alt";
            case RaskColumnButtonTypes.save:
                return "fal fa-save";
            case RaskColumnButtonTypes.copy:
                return "far fa-copy";
            case RaskColumnButtonTypes.edit:
                return "far fa-pen";
            case RaskColumnButtonTypes.forward:
                return "fa-solid fa-forward";
            case RaskColumnButtonTypes.menu:
                return "far fa-ellipsis-vertical";
            default:
                return "";
        }
    }

    isDeleteButton(): boolean {
        return this.buttonType === RaskColumnButtonTypes.delete;
    }
}
